/*
 * Vezron Logo — uses the user-provided PNG logo (with transparent background).
 *
 * Props:
 *   height       — pixel height (default 44)
 *   alt          — accessibility alt text
 */
import React from "react";
import logoImg from "../assets/logo-nav.png";

const Logo = ({ height = 44, alt = "Vezron Technologies" }) => {
  return (
    <span
      className="vz-logo"
      style={{
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
      }}
    >
      <img
        src={logoImg}
        alt={alt}
        style={{
          height,
          width: "auto",
          display: "block",
          filter: "drop-shadow(0 2px 14px rgba(110, 140, 255, 0.4))",
        }}
      />
    </span>
  );
};

export default Logo;
